"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../common/constants/states");
var AdminSchoolEditController = /** @class */ (function () {
    function AdminSchoolEditController($state, $stateParams, SchoolsModel, FlashService, TIMEZONES) {
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.SchoolsModel = SchoolsModel;
        this.FlashService = FlashService;
        this.TIMEZONES = TIMEZONES;
        this.states = states_1.States;
        this.statuses = [
            { name: "Active", value: "ACTIVE" },
            { name: "Staging", value: "STAGING" },
        ];
        this.websites = [];
        // this will be student info pulled from the server later
        SchoolsModel.getSchoolByID($stateParams.schoolId).then(function (response) {
            _this.school = response;
            _this.timezoneOptions = TIMEZONES.map(function (timezone) {
                if (timezone.code === _this.school.timezone) {
                    _this.school.timezone = timezone.code;
                }
                return timezone;
            });
        });
        this.loadWebsites();
    }
    AdminSchoolEditController.prototype.loadWebsites = function () {
        var _this = this;
        this.SchoolsModel.getWebsites(this.$stateParams.schoolId).then(function (response) {
            _this.websites = response.websites;
        });
    };
    AdminSchoolEditController.prototype.addWebsite = function () {
        this.websites.push({ url: "", name: "" });
    };
    AdminSchoolEditController.prototype.saveWebsite = function (website) {
        var _this = this;
        var _a;
        var schoolId = Number(this.$stateParams.schoolId);
        var payload = { url: website.url, name: (_a = website.name) !== null && _a !== void 0 ? _a : null };
        var promise = website.id
            ? this.SchoolsModel.updateWebsite(schoolId, website.id, payload)
            : this.SchoolsModel.addWebsite(schoolId, payload);
        promise.then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.loadWebsites();
        });
    };
    AdminSchoolEditController.prototype.removeWebsite = function (website) {
        var _this = this;
        if (!website.id) {
            this.websites = this.websites.filter(function (row) { return row !== website; });
            return;
        }
        if (!window.confirm("Remove this website?")) {
            return;
        }
        this.SchoolsModel.removeWebsite(Number(this.$stateParams.schoolId), website.id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.loadWebsites();
        });
    };
    AdminSchoolEditController.prototype.submit = function () {
        var _this = this;
        var school = Object.assign({}, this.school);
        var formData = {
            id: school.id,
            name: school.name,
            code: school.code,
            phone: school.phone,
            email: school.email,
            status: school.status,
            timezone: school.timezone,
            setup_complete: school.setup_complete,
            address: {
                street: school.address.street,
                city: school.address.city,
                state: school.address.state,
                zip: school.address.zip,
            },
        };
        this.SchoolsModel.editSchool(formData).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.admin.schools.view", { schoolId: _this.school.id }, { reload: true });
        });
    };
    return AdminSchoolEditController;
}());
AdminSchoolEditController.$inject = [
    "$state",
    "$stateParams",
    "SchoolsModel",
    "FlashService",
    "TIMEZONES",
];
exports.default = AdminSchoolEditController;
